<ngx-daterangepicker-material
    [startDate]="_startDate"
    [endDate]="_endDate"
    [minDate]="_minDate"
    [maxDate]="_maxDate"
    [isInvalidDate]="isInvalidDate"

    [singleDatePicker]="singleDatePicker"
    [timePicker]="timePicker"
    [timePicker24Hour]="timePicker"

    [locale]="locale"

    [showCancel]="true"
    [showDropdowns]="true"

    [autoApply]="true"
    [closeOnAutoApply]="true"
    [linkedCalendars]="false"
    [alwaysShowCalendars]="true"

    (choosedDate)="choosedDate($event)"
    (cancelClicked)="cancelClicked($event)"


>
</ngx-daterangepicker-material>
